<template>
  <footer class="footer has-shadow py-4 px-4">
    <div class="content has-text-centered">
      <p>
        <strong>{{ t('message') }}</strong> {{ t('by') }}
      </p>
    </div>
  </footer>
</template>

<script>
import { useI18n } from 'vue-i18n';
import Translations from '@/translations/footer.json';

export default {
  setup() {
    // Prepare translations
    const { t } = useI18n({
      messages: Translations
    });

    return {
      t
    };
  }
};
</script>

<style>
</style>